import styles from "./IsLoading.module.css";
import { classnames } from "../../utils/index.jsx";

export default function IsLoading() {
  return (
    <div className={styles.card}>
      <div className={styles.avatar}></div>
      <div className={styles.content}>
        <div className={classnames(styles.line, styles.short)}></div>
        <div className={styles.line}></div>
      </div>
    </div>
  );
}
